/** Max history items fetched for the drawer list (ActionLog `limit`). */
export const HISTORY_LOGS_FETCH_LIMIT = 500

/**
 * Display cap for History counters (nav badge + "Found items").
 * Users historically saw at most 500; show "500+" above that.
 */
export const HISTORY_COUNT_DISPLAY_CAP = 500

/**
 * @param {unknown} count
 * @returns {string}
 */
export function formatHistoryCountDisplay(count) {
  const n = typeof count === 'number' ? count : Number(count)
  if (!Number.isFinite(n) || n <= 0) return '0'
  if (n > HISTORY_COUNT_DISPLAY_CAP) return `${HISTORY_COUNT_DISPLAY_CAP}+`
  return String(Math.trunc(n))
}

/**
 * Label for a History list truncated by {@link HISTORY_LOGS_FETCH_LIMIT}.
 * Hitting the limit means more rows may exist → show "500+".
 * @param {unknown} listLength
 * @returns {string}
 */
export function formatHistoryFetchedListCountDisplay(listLength) {
  const n = typeof listLength === 'number' ? listLength : Number(listLength)
  if (!Number.isFinite(n) || n <= 0) return '0'
  if (n >= HISTORY_LOGS_FETCH_LIMIT) return `${HISTORY_COUNT_DISPLAY_CAP}+`
  return String(Math.trunc(n))
}
